import axiosInstance from "@/api/axiosInstance";
import {
  EmailTemplate,
  UpdateEmailTemplateRequest,
  EmailTemplatePreview,
  PreviewEmailTemplateRequest,
} from "../types";

/**
 * API client for managing email template settings
 */
export const emailTemplateApi = {
  /**
   * Fetches the current email template settings
   * @returns Promise resolving to the current email template
   */
  getTemplate: async (): Promise<EmailTemplate> => {
    const response = await axiosInstance.get(`/api/private/notifications/email-template`);
    return response.data.data;
  },

  /**
   * Updates the email template settings
   * @param template - The updated template configuration
   * @returns Promise resolving to the updated email template
   */
  updateTemplate: async (template: UpdateEmailTemplateRequest): Promise<EmailTemplate> => {
    const response = await axiosInstance.put(
      `/api/private/notifications/email-template`,
      template
    );
    return response.data.data;
  },

  /**
   * Previews the email template with sample data
   * @param request - Template and optional sample data for preview
   * @returns Promise resolving to the rendered email preview
   */
  previewTemplate: async (request: PreviewEmailTemplateRequest): Promise<EmailTemplatePreview> => {
    const response = await axiosInstance.post(
      `/api/private/notifications/email-template/preview`,
      request
    );
    return response.data.data;
  },

  /**
   * Resets the email template to default settings
   * @returns Promise resolving to the default email template
   */
  resetToDefault: async (): Promise<EmailTemplate> => {
    const response = await axiosInstance.post(
      `/api/private/notifications/email-template/reset`
    );
    return response.data.data;
  },
};